import { array, object, str, type FieldParser } from 'validation';

// Server-supplied folder path (nap-backend #1076): root→leaf, each level
// carrying its name and the zone it lives in. `null` when the object has no
// folder.
//
// Shared here by true IDENTITY: the backend produces `folder_path` from ONE
// serializer — `buildFolderPath` (modules/generic_functions/folderUtils.js) —
// for every folder-bearing resource (connections, events, locks,
// recurrence_definitions, scheduling_windows, tables, triggers, …). Same code,
// same shape, so the wire type + schema live once in api/shared and each
// resource imports them; see ../README.md ("Type sharing").
export type FolderPath = { readonly zoneName: string; readonly name: string }[];

const folderPathEntrySchema = object<{ zoneName: string; name: string }>({
  zoneName: str(),
  name: str(),
});

export const folderPathSchema: FieldParser<FolderPath> = array(folderPathEntrySchema);
